export default "__VITE_ASSET__CHOK4He___"